<template>
  <div class="OverviewsAccesesData w-full flex justify-start items-start flex-col">
    <button 
      v-if="type === 'members'"
      class="backBtnWrapper w-full flex justify-start items-center mb-2 text-bc-blue"
      @click.stop.prevent="goBack()"
    >
      <aw-icon 
        icon="chevron-left" 
        class="w-8 h-8 -ml-2"
      />
      {{ $t('Back') }}
    </button>
    <overviews-tab-header
      v-if="type === 'teams'"
      v-model="searchQueryTeams"
    >
      <h2 class="block text-lg font-medium">
        {{ $t('Teams') }}
      </h2>
    </overviews-tab-header>
    <overviews-tab-header
      v-if="type === 'members'"
      v-model="searchQueryMembers"
    >
      <a 
        class="block text-lg font-medium hover:text-bc-blue cursor-pointer"
        :href="selectedTeam.detail_url" 
        target="_blank"
      >
        {{ selectedTeam.name }}
      </a>
    </overviews-tab-header>
    <div class="w-full flex justify-start items-start flex-col">
      <overviews-loading v-if="loading || loadingMembers"/>
      <overviews-loading-error v-else-if="loadingError"/>
      <overviews-no-results v-else-if="(type === 'teams' && filteredTeamsBySearch?.length === 0) || (type === 'members' && filteredMembersBySearch?.length === 0)"/>
      <template v-else-if="type === 'teams' && filteredTeamsBySearch?.length > 0">
        <overviews-access-team
          v-for="item in filteredTeamsBySearch"
          :key="item.team.id"
          :team="item"
          @click.stop.prevent="selectTeam(item.team)"
        />
      </template>
      <template v-else-if="type === 'members' && filteredMembersBySearch?.length > 0">
        <overviews-access-team-member
          v-for="visit in filteredMembersBySearch"
          :key="visit.id"
          :visit="visit"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { search } from 'ss-search'
import useBcOverviewsModalStore from '@/frontapp/store/bcOverviewsModal'
import { DocumentApi, FolderApi } from '@/frontapp/test-api'
import handleApiError from '../../utils/handleApiError'

const documentApi = new DocumentApi({}, '/api/v2')
const folderApi = new FolderApi({}, '/api/v2')

export default {
  props: {
  },
  data() {
    return {
      searchQueryTeams: null,
      searchQueryMembers: null,
      selectedTeam: null,
      loadingMembers: false,
      type: 'teams',
      loading: false,
      loadingError: false,
      data: null,
      apiHandler: null,
    }
  },
  computed: {
    ...mapStores(useBcOverviewsModalStore),
    filteredTeamsBySearch() {
      if (!this.searchQueryTeams || this.searchQueryTeams.length < 1) {
        return this.data
      }

      const searchedTeams = search(this.data, ['team.name'], this.searchQueryTeams)
      return searchedTeams
    },
    filteredMembersBySearch() {
      if (!this.searchQueryMembers || this.searchQueryMembers.length < 1) {
        return this.selectedTeam.fetchedUsers
      }
      
      const searchedMesearchQueryMembers = search(this.selectedTeam.fetchedUsers, ['user.name', 'user.surname', 'user.email'], this.searchQueryMembers)
      return searchedMesearchQueryMembers
    },
  },
  methods: {
    goBack() {
      this.type = 'teams'
      this.selectedTeam = null
    },
    async selectTeam(team) {
      this.loadingMembers = true
      this.searchQueryMembers = null
      this.selectedTeam = JSON.parse(JSON.stringify(team))
      this.type = 'members'
      const response = await handleApiError(() => this.apiHandler[this.bcOverviewsModalStore.type + 'Team'](this.bcOverviewsModalStore.id, team.id))
      this.selectedTeam.fetchedUsers = response.data.users
      this.loadingMembers = false
    },
    async handleApi() {
      this.loading = true
      this.loadingError = false

      if (this.bcOverviewsModalStore.type === 'document') {
        this.apiHandler = documentApi
      } else {
        this.apiHandler = folderApi
      }
    
      try {
        const response = await this.apiHandler[this.bcOverviewsModalStore.type + 'Access'](this.bcOverviewsModalStore.id)
        this.data = response.data
      } catch (err) {
        this.loadingError = true
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.handleApi()
  },
  watch: {
    'bcOverviewsModalStore.show': {
      handler(val) {
        if (!val) {
          this.goBack()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.OverviewsAccesesData:has(.backBtnWrapper) .headerWrapper {
  margin-top: 0;
}

.backBtnWrapper {
  min-height: 40px;
}
</style>
